import React from 'react';
import {Search} from 'lucide-react';
import Card from '../../../../Presentation/components/ui/Card';
import {SearchableSelect} from '../../../../Presentation/components/ui/SearchableSelect';
import {KSA_CITIES} from '../../../../constants/ksaCities';

interface StoresListFiltersProps {
  search: string;
  paymentStatusFilter: string;
  cityFilter: string;
  districtFilter: string;
  onSearchChange: (value: string) => void;
  onPaymentStatusChange: (value: string) => void;
  onCityChange: (value: string) => void;
  onDistrictChange: (value: string) => void;
  onFilter: () => void;
}

const CITY_OPTIONS = Object.keys(KSA_CITIES);

export const StoresListFilters: React.FC<StoresListFiltersProps> = ({
  search,
  paymentStatusFilter,
  cityFilter,
  districtFilter,
  onSearchChange,
  onPaymentStatusChange,
  onCityChange,
  onDistrictChange,
  onFilter
}) => {
  const districtOptions = cityFilter ? (KSA_CITIES[cityFilter] ?? []) : [];

  return (
    <Card className="p-6">
      <div className="flex gap-4 flex-wrap">
        <input
          className="flex-1 min-w-[200px] border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-primary/30 focus:border-brand-500"
          placeholder="بحث باسم المتجر أو المدير أو رقم الهاتف أو العنوان"
          value={search}
          onChange={e => onSearchChange(e.target.value)}
        />
        <SearchableSelect
          className="min-w-[180px]"
          value={cityFilter}
          options={CITY_OPTIONS}
          onChange={onCityChange}
          placeholder="كل المدن"
        />
        <SearchableSelect
          className="min-w-[180px]"
          value={districtFilter}
          options={districtOptions}
          onChange={onDistrictChange}
          disabled={!cityFilter}
          placeholder="كل الأحياء"
          disabledPlaceholder="اختر المدينة أولاً"
        />
        <select
          className="border border-gray-300 rounded-md px-3 py-2 focus:ring-2 focus:ring-primary/30 focus:border-brand-500"
          value={paymentStatusFilter}
          onChange={e => onPaymentStatusChange(e.target.value)}
        >
          <option value="">جميع حالات الدفع</option>
          <option value="مدفوع">مدفوع</option>
          <option value="معلق">معلق</option>
          <option value="متأخر">متأخر</option>
        </select>
        <button
          className="bg-brand-600 text-white px-6 py-2 rounded-md hover:bg-brand-700 transition-colors flex items-center gap-2"
          onClick={onFilter}
        >
          <Search className="w-4 h-4" />
          تصفية
        </button>
      </div>
    </Card>
  );
};
